import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const CustomButtonsFormulario = ({
  // Props para modo estándar (4 botones en grid)
  onCancelar,
  onProximo,
  onInexistente,
  onNoControlar,
  proximoDeshabilitado = false,
  loading = false,
  customLabels = {},
  mode = "standard", // "standard" | "custom"
  onFinalizar,
  extraData,
}) => {
  const theme = useTheme();

  const buttonStyle = {
    boxShadow: 0,
    fontWeight: "bold",
    fontSize: 14,
    color: "#000",
    backgroundColor: theme.bandera?.colorSecundario || "#004280",
    ":hover": {
      backgroundColor: theme.bandera?.colorSecundario || "#004280",
    },
    ":disabled": {
      backgroundColor: "#cccccc",
      color: "#666666",
    },
  };

  const labels = {
    cancelar: "Cancelar",
    proximo: "Próximo",
    inexistente: "Inexistente",
    noControlar: "No controlar",
    finalizar: "Finalizar",
    ...customLabels,
  };

  // Modo estándar: 4 botones en grid (FormularioButtons)
  if (mode === "standard") {
    return (
      <Grid container spacing={1} mt={1}>
        <Grid item xs={6}>
          <Button fullWidth variant="contained" color="secondary" onClick={onCancelar} disabled={loading} sx={buttonStyle}>
            {labels.cancelar}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button fullWidth variant="contained" onClick={onProximo} disabled={proximoDeshabilitado || loading} sx={buttonStyle}>
            {labels.proximo}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button fullWidth variant="contained" onClick={onInexistente} disabled={loading} sx={buttonStyle}>
            {labels.inexistente}
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button fullWidth variant="contained" onClick={onNoControlar} disabled={loading} sx={buttonStyle}>
            {labels.noControlar}
          </Button>
        </Grid>
      </Grid>
    );
  }

  if (mode === "custom") {
    return (
      <Box py={2} bgcolor="#fff" display="flex" flexDirection="column" alignItems="center">
        <Box width={310}>
          {/* Botones Cancelar / Próximo alineados */}
          <Box display="flex" justifyContent="space-between" mt={1}>
            <Button
              variant="contained"
              sx={{
                ...buttonStyle,
                width: "48%",
              }}
              onClick={onCancelar}
              disabled={loading}
            >
              {labels.cancelar}
            </Button>
            <Button
              variant="contained"
              sx={{
                ...buttonStyle,
                width: "48%",
              }}
              onClick={onProximo}
              disabled={proximoDeshabilitado || loading}
            >
              {labels.proximo}
            </Button>
          </Box>

          {/* Botón Finalizar centrado */}
          {onFinalizar && (
            <Button
              fullWidth
              variant="contained"
              sx={{
                ...buttonStyle,
                mt: 2,
              }}
              onClick={onFinalizar}
              disabled={extraData?.length === 0 || loading}
            >
              {labels.finalizar}
            </Button>
          )}
        </Box>
      </Box>
    );
  }

  return null;
};

export default CustomButtonsFormulario;
